import { ILogsOverride } from './logs-override.model';

export function disableLogs(): void {
  window.console.log = () => {};
  window.console.warn = () => {};
}

export function overrideLogs(config: ILogsOverride, originalLog: (...args: any[]) => void): void {
  window.console.log = (...args: any[]) => {
    if (shouldLogAll(config)) {
      originalLog(...args);
    } else if (hasLogLevel(args, config)) {
      logFiltered(args, originalLog);
    }
  };
}

export function shouldLogAll(config: ILogsOverride): boolean {
  return !config.logLevel;
}

export function hasLogLevel(args: any[], config: ILogsOverride): boolean {
  return args.findIndex((arg) => arg === config.logLevel) !== -1;
}

export function logFiltered(args: any[], originalLog: (...args: any[]) => void): void {
  originalLog(...args);
}
